import { Center } from '@tempots/beatui'
import { attr, html, TNode } from '@tempots/dom'
import { Logo } from '@/components/ui'

export function AuthLayout(...children: TNode[]) {
  return html.div(
    attr.class('bg-gray-100 h-full overflow-hidden'),
    Center(
      {},
      html.div(
        attr.class(
          'flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12 bg-white flex flex-col gap-6 sm:shadow-lg sm:rounded-lg w-full h-full sm:h-auto sm:w-120 overflow-y-auto'
        ),
        Logo({ displaySlogan: false }),
        ...children
      )
    )
  )
}
